import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Authorize } from '../../../state/models/authorize';

@Injectable({
  providedIn: 'root'
})
export class PatientService {

  private entitySubject = new BehaviorSubject<Authorize>(null);

  constructor() {
  }

  getAuthorize$(): Observable<Authorize> {
    return this.entitySubject.asObservable();
  }

  getAuthorize(): Authorize {
    return this.entitySubject.getValue();
  }

  setAuthorize(value: Authorize) {
    this.entitySubject.next(value);
  }

}
